

import React, {Component} from 'react'

import PlusToolbarButton from '../details/toolbar/PlusToolbarButton';
import MinusToolbarButton from '../details/toolbar/MinusToolbarButton';
import ExitToolbarButton from '../details/toolbar/ExitToolbarButton';
import CancelToolbarButton from '../details/toolbar/CancelToolbarButton';
import PrintToolbarButton from '../details/toolbar/PrintToolbarButton';
import PayToolbarButton from '../details/toolbar/PayToolbarButton';

class HToolbar extends Component 
{
    render()
    {

        let components = [];

        components.push(<MinusToolbarButton/>);
        components.push(<PlusToolbarButton/>);
        components.push(<PrintToolbarButton/>);
        components.push(<CancelToolbarButton/>);
        components.push(<PayToolbarButton/>);
        components.push(<ExitToolbarButton/>);

        return <div className='h-100 w-100 d-flex flex-wrap flex-row' style={{
                        borderRadius: "var(--button-roundness)",
                        overflow: "hidden",
                        boxShadow: "inset 0 0 0 1px var(--colors-primary)"}}>
                    {components}
               </div>
    }
}

export default HToolbar